// Voice options data with characteristics
export const voiceOptions = [
  {
    id: 'us-female-1',
    countryCode: 'US',
    accent: 'American Accent',
    gender: 'Female',
    genderIcon: '♀',
    characteristics: 'Cheerful Sharp Fast',
    voiceName: 'Google US English Female',
    fallbackVoice: null
  },
  {
    id: 'us-female-2',
    countryCode: 'US',
    accent: 'American Accent',
    gender: 'Female',
    genderIcon: '♀',
    characteristics: 'Upbeat Lively Enthusiastic',
    voiceName: 'Samantha',
    fallbackVoice: null
  },
  {
    id: 'us-male-1',
    countryCode: 'US',
    accent: 'American Accent',
    gender: 'Male',
    genderIcon: '♂',
    characteristics: 'Lively Excited Fun',
    voiceName: 'Google US English Male',
    fallbackVoice: null
  },
  {
    id: 'au-male-1',
    countryCode: 'AU',
    accent: 'Australian Accent',
    gender: 'Male',
    genderIcon: '♂',
    characteristics: 'Cheerful Sharp Fast',
    voiceName: 'Google Australian English Male',
    fallbackVoice: null
  },
  {
    id: 'gb-female-1',
    countryCode: 'GB',
    accent: 'British Accent',
    gender: 'Female',
    genderIcon: '♀',
    characteristics: 'Polite Elegant Clear',
    voiceName: 'Google UK English Female',
    fallbackVoice: null
  },
  {
    id: 'gb-male-1',
    countryCode: 'GB',
    accent: 'British Accent',
    gender: 'Male',
    genderIcon: '♂',
    characteristics: 'Wise Gentle Steady',
    voiceName: 'Google UK English Male',
    fallbackVoice: null
  },
  {
    id: 'de-female-1',
    countryCode: 'DE',
    accent: 'German Accent',
    gender: 'Female',
    genderIcon: '♀',
    characteristics: 'Precise Clear Helpful',
    voiceName: 'Google Deutsch Female',
    fallbackVoice: null
  },
  {
    id: 'in-female-1',
    countryCode: 'IN',
    accent: 'Indian Accent',
    gender: 'Female',
    genderIcon: '♀',
    characteristics: 'Clear Helpful Friendly',
    voiceName: 'Google हिन्दी Female',
    fallbackVoice: null
  }
];

// Language code mapping for voice selection
export const getLanguageCode = (countryCode) => {
  const languageMap = {
    'US': 'en-US',
    'GB': 'en-GB', 
    'AU': 'en-AU',
    'DE': 'de-DE',
    'IN': 'hi-IN'
  };
  return languageMap[countryCode] || 'en-US';
};

// Gender color mapping
export const getGenderColor = (gender) => {
  return gender === 'Female' ? 'text-pink-400' : 'text-blue-400';
};
